import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-job-learning-feedback',
  templateUrl: './job-learning-feedback.component.html',
  styleUrls: ['./job-learning-feedback.component.scss'],
})
export class JobLearningFeedbackComponent  implements OnInit {


 filteredAssets: any = [];
  searchTerm: string = '';
  attendanceForm!: FormGroup;

  constructor(private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.attendanceForm = this.fb.group({
      selectedProgram: [''],
      selectedStatus: [''],
      searchTerm: ['']
    });
  }



  filterAssets(searchTerm: string) {
    console.log(searchTerm);
  }

  programList: string[] = ['Program 1', 'Program 2']; 
  managerList: string[] = ['manager1', 'manager2']; 
// Employee training scores data
trainingScores = [
  {
    empCode: 'B001',
    empName: 'Ram',
    scores: [3, 4, 2], // Q1, Q2, Q3 scores
  },
  {
    empCode: 'B002',
    empName: 'Laksham',
    scores: [4, 5, 4], // Q1, Q2, Q3 scores
  }
];

// Compute the average score per employee
getEmployeeAverage(scores: number[]): number {
  const sum = scores.reduce((acc, score) => acc + score, 0);
  return parseFloat((sum / scores.length).toFixed(2));
}

// Compute the average question score (column-wise average)
getQuestionAverages(): number[] {
  const numQuestions = this.trainingScores[0].scores.length;
  const averages = [];

  for (let i = 0; i < numQuestions; i++) {
    let sum = 0;
    this.trainingScores.forEach(emp => sum += emp.scores[i]);
    averages.push(parseFloat((sum / this.trainingScores.length).toFixed(2)));
  }

  return averages;
}

// Compute overall program average score
getProgramAverage(): number {
  const totalScores = this.trainingScores.map(emp => this.getEmployeeAverage(emp.scores));
  const sum = totalScores.reduce((acc, avg) => acc + avg, 0);
  return parseFloat((sum / totalScores.length).toFixed(2));
}

}
